import moment from "moment-timezone";

export default values => {
    const errors = {};
    const requiredFields = ["status", "description"];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });
    if (!values.channel || !values.channel.id || !values.channel.name) {
        errors["channel"] = "Required";
    }

    if (values["status"] === "scheduled") {
        if (!values["publicationDate"]) {
            errors["publicationDate"] = "Required";
        } else if (moment(values["publicationDate"]).diff(moment()) <= 0) {
            errors["publicationDate"] = "Scheduled date must be in the future";
        }
    }
    if (values["hasArticle"]) {
        if (!values["article"]) {
            errors["article"] = "Required";
        }
    }

    if (values["charCount"] && parseInt(values["charCount"]) > 500) {
        errors["description"] = "We recommend you keep posts to around 500 characters";
    }

    if (values["charCountArticle"] && parseInt(values["charCountArticle"]) > 2000) {
        errors["article"] = "We recommend you keep posts to around 2000 characters";
    }

    return errors;
};
